import { Component } from '@angular/core';
import { TuiButton, TuiIcon } from '@taiga-ui/core';
import { TuiChip } from '@taiga-ui/kit';

@Component({
  selector: 'app-careers-jobs-section',
  templateUrl: './careers-jobs-section.component.html',
  styleUrls: ['./careers-jobs-section.component.scss'],
  standalone: true,
  imports: [TuiIcon, TuiButton, TuiChip],
})
export class CareersJobsSectionComponent {
  protected readonly emailCareers = 'careers@capawesome.io';
}
